import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import Summary from 'components/Summary/Summary'
import { AppLinks } from 'enviroment/AppLinks'
import { ChooseIdentityMethodTypes, IChooseIdentityMethodPageProps } from 'pages/ChooseIdentityMethodPage/ChooseIdentityMethodPageProps'
import useTextContents from 'common/hooks/useTextContents'
import useIsMobile from 'common/hooks/useIsMobile'
import { AppState } from 'store'
import { BasicInfoFieldsNames } from 'FormDefinitions/BasicInfoForm/BasicInfoFields'
import videoVerificationService from 'service/VideoVerificationService/VideoVerificationService'
import { setGenerateSessionParams } from 'store/VideoVerificationSlice/VideoVerificationSlice'
import { createVideoVerificationIdentificationLink } from 'common/helpers/videoVerificationHelper'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import analyticsService from 'service/AnalyticsService/AnalyticsService'

import {ReactComponent as IdentLogo} from '../../../assets/ident_logo.svg'
import './VideoVerificationStartPageStyles.scss'

const sendIdentificationVideoVerificationEvent = async(eventTypeName?: string) => {
   try {
      await analyticsService.createSingleAnalyticEvent(eventTypeName)
   }
   catch(error) {
      console.warn('Nie udało się zapisać eventu wideoweryfikacji.', error)
   }
}

const VideoVerificationStartPage = (props: IChooseIdentityMethodPageProps) => {
   const isMobileDevice = useIsMobile()
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const videoVerificationPageTextContents = useTextContents()
   const isIdentityPage = Boolean(props.chooseIdentityMethodType === ChooseIdentityMethodTypes.IDENTITY)
   const email = useSelector((state: AppState) => state.formState[BasicInfoFieldsNames.Email].value) as string
   const analyticsEventTypesNames = useSelector((state: AppState) => state.globalConfigurationState.analyticsEventTypesNames)

   const handleOnSubmitButtonClick = async () => {
      navigate(AppLinks.waiting)

      if(isIdentityPage) {
         await sendIdentificationVideoVerificationEvent(analyticsEventTypesNames?.IdentificationVideoVerificationStarted)
      }

      const generateVideoVerificationSessionResponse = await videoVerificationService.generateSession({ email })
      dispatch(setGenerateSessionParams(generateVideoVerificationSessionResponse))
      const videVerificationLink = createVideoVerificationIdentificationLink({...generateVideoVerificationSessionResponse, chooseIdentityMethodType: props.chooseIdentityMethodType})

      if(isIdentityPage) {
         await sendIdentificationVideoVerificationEvent(analyticsEventTypesNames?.IdentificationVideoVerificationIdenttEntrance)
      }

      window.location.href = videVerificationLink
   }
   
   const handleOnPrevButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()

      navigate(isIdentityPage ? AppLinks.chooseIdentityMethod : AppLinks.chooseVerificationMethod)
   }

   return (
      <div className='video-verification-start-page-main-wrapper'>
         <section className='video-verification-start-page-outer-section-wrapper'>
            <div className='video-verification-start-page-heading-wrapper'>
               <h1>{videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.first_section.heading' : 'videoVerificationStartPage.verification.first_section.heading')}</h1>
               <p>{videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.first_section.subheading' : 'videoVerificationStartPage.verification.first_section.subheading')}</p>
               <ul>
                  <li dangerouslySetInnerHTML={{__html: videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.first_section.list_option_1' : 'videoVerificationStartPage.verification.first_section.list_option_1')}} />
                  <li dangerouslySetInnerHTML={{__html: videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.first_section.list_option_2' : 'videoVerificationStartPage.verification.first_section.list_option_2')}} />
                  <li dangerouslySetInnerHTML={{__html: videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.first_section.list_option_3' : 'videoVerificationStartPage.verification.first_section.list_option_3')}} />
               </ul>
            </div>
            <div className='video-verification-start-page-instruction-wrapper'>
               <h4>{videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.second_section.heading' : 'videoVerificationStartPage.verification.second_section.heading')}</h4>
               <ol className='video-verification-start-page-instruction-list'>
                  <li>{videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.second_section.list_option_1' : 'videoVerificationStartPage.verification.second_section.list_option_1')}</li>
                  <li>{videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.second_section.list_option_2' : 'videoVerificationStartPage.verification.second_section.list_option_2')}</li>
                  <li>{videoVerificationPageTextContents(isIdentityPage? 'videoVerificationStartPage.identity.second_section.list_option_3' : 'videoVerificationStartPage.verification.second_section.list_option_3')}</li>
               </ol>
            </div>
            <Button
               uiButtonType={AppButtonTypes.PRIMARY} 
               buttonContent={videoVerificationPageTextContents('buttons.videoVerificationStartProcess')} 
               className='video-verification-start-page-submit-button  page-main-button-submission-button' 
               onClick={handleOnSubmitButtonClick}
            />
            <IdentLogo className='video-verification-start-page-ident-logo'/>
            <Button style={{ textTransform: 'none' }} buttonContent={videoVerificationPageTextContents('buttons.chooseAnotherVerificationMethod')} className='page-application-prev-button' onClick={handleOnPrevButtonClick} />
            <ButtonCancelApplication />
         </section>
         {!isMobileDevice && <Summary isExtended={true} />}
      </div>
   )
}

export default VideoVerificationStartPage